import { useEffect, useRef, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { useAuth } from "../context/userContext"

/* Opened from the link in the confirmation email; confirms straight away */
const VerifyEmail = () => {
  const { ev_str } = useParams()
  const { user, refreshUser } = useAuth()
  const [status, setStatus] = useState("working") // working | done | failed
  const [error, setError] = useState("")
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return // the link only works once
    started.current = true
    ;(async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/verify/${ev_str}`, {
          method: "POST",
          credentials: "include",
        })
        const data = await res.json().catch(() => ({}))
        if (!res.ok) throw new Error(data.message || "This link didn't work")
        await refreshUser()
        setStatus("done")
      } catch (err) {
        setError(err.message)
        setStatus("failed")
      }
    })()
  }, [ev_str, refreshUser])

  return (
    <div className="d-flex justify-content-center align-items-center px-3" style={{ minHeight: "70vh" }}>
      <div className="text-center border rounded-3 bg-light p-4 p-md-5" style={{ maxWidth: 520 }} role="status">
        {status === "working" && (
          <>
            <div className="spinner-border text-success mb-3" aria-hidden="true" />
            <h1 className="h3">Confirming your email…</h1>
          </>
        )}

        {status === "done" && (
          <>
            <div className="fs-1 mb-2" aria-hidden="true">✅</div>
            <h1 className="h2 mb-3">Email confirmed</h1>
            <p className="mb-4">Thanks! Your account is ready.</p>
            <Link className="btn btn-success btn-lg" to={user ? "/account" : "/login"}>
              {user ? "Go to my account" : "Log in"}
            </Link>
          </>
        )}

        {status === "failed" && (
          <>
            <div className="fs-1 mb-2" aria-hidden="true">⚠️</div>
            <h1 className="h2 mb-3">We couldn't confirm your email</h1>
            <p className="mb-4">{error}</p>
            <Link className="btn btn-success" to={user ? "/verify-email" : "/login"}>
              {user ? "Send a new link" : "Log in to get a new link"}
            </Link>
          </>
        )}
      </div>
    </div>
  )
}

export default VerifyEmail
